import React, { createContext, useContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import useAuth from '../hooks/useAuth';

// Create a context for socket connection
const SocketContext = createContext();

// This hook will be used by other components to access the socket connection
export const useSocket = () => {
  return useContext(SocketContext);
};

// SocketProvider component to wrap the entire app
export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const {authenticated}  = useAuth();

    // Initialize the socket connection here
    useEffect( () => {
        if (authenticated?.user?._id) {
          // Initialize the socket connection only if the user is logged in
   
        const newSocket =   io("https://playerzportal.mnrhub.com", {
          withCredentials: true, // If using credentials like cookies
          query: { userId: authenticated?.user?._id },
        });
        console.log(newSocket);
       // Listen for the socket connection
       newSocket.on('connect', () => {
        console.log("Socket connected with ID:", newSocket?.id, newSocket);
        setSocket(newSocket);
      });
      newSocket.on('disconnect', () => {
        console.log("Socket disconnected with ID:", newSocket?.id, newSocket);
        setSocket(null);
      });

      newSocket.on('connect_error', (err) => {
        console.error('Connection failed:', err);
      });
  
        setSocket(newSocket);
  
          
          // Cleanup on unmount
          // return () => {
          //   if (socket) {
          //     socket.disconnect();
          //     console.log("Socket disconnected");
          //   }
          // }



          // console.log(authenticated?.user?._id,"this is with login")

        }
        setSocket(null)
        // console.log(authenticated?.user?._id,"this is without login")
      }, [authenticated?.user?._id]);

  return (
    <SocketContext.Provider value={{socket,setSocket}}>
      {children}
    </SocketContext.Provider>
  );
};
